import React, { useEffect, useRef, useState } from "react";
import {
    MDBCard,
    MDBCardBody,
    MDBIcon,
    MDBTypography,
    MDBProgress,
    MDBProgressBar,
    MDBDropdown,
    MDBDropdownToggle,
    MDBDropdownMenu,
    MDBDropdownItem,
    MDBLoadingManagement,
} from "mdb-react-ui-kit";



export default function CustomAudioPlayer({ source, greetingName, filetitle, editClick, showLoader }) {
    console.log(source, "audio source");
    const audioRef = useRef(null);
    const isAudioAvailable = Boolean(source);
    const [isPlaying, setIsPlaying] = useState(false);
    const [progress, setProgress] = useState(0);
    const [currentTime, setCurrentTime] = useState("00:00");
    const [duration, setDuration] = useState("00:00");
    const [muted, setMuted] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const basicRef = useRef(null);

    const formatTime = (time) => {
        // Check if time is valid
        if (!time || !isFinite(time) || isNaN(time)) {
            return "00:00";
        }
        
        const mins = Math.floor(time / 60)
            .toString()
            .padStart(2, "0");
        const secs = Math.floor(time % 60)
            .toString()
            .padStart(2, "0");
        return `${mins}:${secs}`;
    };

    const handlePlayPause = () => {
        const audio = audioRef.current;
        if (!audio) return;

        if (isPlaying) {
            audio.pause();
        } else {
            audio.play().catch((error) => {
                console.error("Error playing audio:", error);
                setIsPlaying(false);
            });
        }
        setIsPlaying(!isPlaying);
    };

    const handleTimeUpdate = () => {
        const audio = audioRef.current;
        if (!audio || !isFinite(audio.duration)) return;
        
        const percent = (audio.currentTime / audio.duration) * 100 || 0;
        setProgress(percent);
        setCurrentTime(formatTime(audio.currentTime));
    };

    const handleLoadedMetadata = () => {
        const audio = audioRef.current;
        if (!audio) {
            setDuration("--:--")
            return;
        }
        console.log("Audio duration:", audio.duration);
        
        // Check if duration is valid
        if (isFinite(audio.duration) && !isNaN(audio.duration)) {
            setDuration(formatTime(audio.duration));
            setIsLoading(false);
        } else {
            // Try alternative method for getting duration
            handleDurationChange();
        }
    };

    const handleDurationChange = () => {
        const audio = audioRef.current;
        if (!audio){
             setDuration("--:--")
          return;  
        } 
        
        console.log("Duration changed:", audio.duration);
        
        if (isFinite(audio.duration) && !isNaN(audio.duration)) {
            setDuration(formatTime(audio.duration));
            setIsLoading(false);
        }
    };

    const handleCanPlay = () => {
        const audio = audioRef.current;
        if (!audio) return;
        
        // Sometimes duration is available at canplay event
        if (isFinite(audio.duration) && !isNaN(audio.duration)) {
            setDuration(formatTime(audio.duration));
            setIsLoading(false);
        }
    };

    const handleLoadedData = () => {
        const audio = audioRef.current;
        if (!audio) return;
        
        // Final attempt to get duration
        if (isFinite(audio.duration) && !isNaN(audio.duration)) {
            setDuration(formatTime(audio.duration));
            setIsLoading(false);
        } else {
            console.warn("Duration still not available after loadeddata event");
        }
    };

    const handleSeek = (e) => {
        const audio = audioRef.current;
        if (!audio || !isFinite(audio.duration)) return;
        
        const progressContainer = e.currentTarget;
        const rect = progressContainer.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const width = rect.width;
        const percent = (clickX / width) * 100;

        const newTime = (percent / 100) * audio.duration;
        audio.currentTime = newTime;
        setProgress(percent);
    };

    const handleError = (e) => {
        console.error("Audio error:", e);
        setIsLoading(false);
        setDuration("--:--");
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            const audio = audioRef.current;
            if (!audio || !isFinite(audio.duration)) return;

            switch (e.code) {
                // case "Space":
                //     e.preventDefault(); // prevent scrolling
                //     handlePlayPause();
                //     break;
                case "ArrowRight":
                    audio.currentTime = Math.min(audio.duration, audio.currentTime + 5);
                    break;
                case "ArrowLeft":
                    audio.currentTime = Math.max(0, audio.currentTime - 5);
                    break;
                case "KeyM":
                    audio.muted = !audio.muted;
                    setMuted(audio.muted);
                    break;
                case "KeyS":
                    audio.pause();
                    audio.currentTime = 0;
                    setIsPlaying(false);
                    setProgress(0);
                    setCurrentTime("00:00");
                    break;
                default:
                    break;
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [isPlaying]);

    // Reset states when source changes
    useEffect(() => {
        if (source) {
            setIsLoading(true);
            setDuration("00:00");
            setCurrentTime("00:00");
            setProgress(0);
            setIsPlaying(false);
        }else{
            setCurrentTime("00:00");
            setProgress(0);
            setDuration("00:00");
        }
    }, [source]);

    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = source;
        link.download = filetitle || "audio.mp3"; // fallback filename if none provided
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleEnded = () => {
        setIsPlaying(false);
        setProgress(0);
        setCurrentTime("00:00");
        // Reset audio to beginning
        const audio = audioRef.current;
        if (audio) {
            audio.currentTime = 0;
        }
    };

    if (filetitle === "System Default") {
        return (
            <MDBCard className="rounded-4 shadow-0 p-0 border w-100 px-4 py-0">
                <MDBCardBody className="px-4 bg-transparent position-relative d-flex justify-content-between align-items-center">
                    <MDBTypography tag="p" className="fw-bold mb-0">
                        System Default
                    </MDBTypography>
                    {editClick && (
                        <MDBIcon
                            fas
                            icon="pen"
                            size="sm"
                            className="text-primary cursor-pointer"
                            onClick={editClick}
                        />
                    )}
                </MDBCardBody>
            </MDBCard>
        );
    }


    return (
        <>
            <MDBCard className="rounded-4 shadow-0 p-0 border w-100 px-4" >
                <MDBCardBody className="px-4 bg-transparent position-relative">
                    {/* <MDBTypography tag="p" className="fw-bold text-center">
                        {greetingName}
                    </MDBTypography> */}
                   
                    <MDBTypography
                        tag="p"
                        className="voice-audio fw-bold text-center mb-3 d-flex justify-content-center"
                    >
                        {showLoader && (
                        <div className="mini-spinner" ref={basicRef} style={{ zIndex: "1029" }}>
                            <MDBLoadingManagement parentRef={basicRef} />
                        </div> 
                        )}
                    {filetitle}
                    </MDBTypography>
                    <div
                        onClick={isAudioAvailable ? handleSeek : undefined}
                        className={isAudioAvailable ? "cursor-pointer" : "disabled"}
                    >
                        <MDBProgress height="5" className="mb-2" style={{ borderRadius: 10 }}>
                            <MDBProgressBar width={isAudioAvailable ? progress : 0} />
                        </MDBProgress>
                    </div>

                    <div className="d-flex justify-content-between mb-2">
                        <small>{currentTime}</small>
                        <small>{isLoading ? "..." : duration}</small>
                    </div>

                    <div className="d-flex justify-content-center align-items-center gap-4">
                        {/* <MDBIcon fas icon="backward" size="lg" className={!isAudioAvailable ? "text-muted" : "cursor-pointer"} /> */}
                        <div onClick={() => isAudioAvailable && handlePlayPause()} className={isAudioAvailable ? "cursor-pointer play-pause-button" : "text-muted"}>
                            <MDBIcon fas icon={isPlaying ? "pause" : "play"} size="lg" className={!isAudioAvailable ? "text-muted" : "cursor-pointer"} />
                        </div>
                        {/* <MDBIcon fas icon="forward" size="lg" className={!isAudioAvailable ? "text-muted" : "cursor-pointer"} /> */}
                    </div>
                    <MDBDropdown className={`more-options-button${showLoader ? " disable-edit" : ""}`}>
                        <MDBDropdownToggle tag='button' className='seq-header-btn  border-0 shadow-0'>
                            <MDBIcon fas icon='ellipsis-v' color='primary' size='lg' />
                        </MDBDropdownToggle>
                        <MDBDropdownMenu>
                            {/* <MDBDropdownItem disabled={!isAudioAvailable} link onClick={handleDownload}>
                                Download
                            </MDBDropdownItem> */}
                            <MDBDropdownItem link onClick={(e) => {e.preventDefault(); editClick()}}>
                                Edit
                            </MDBDropdownItem>
                        </MDBDropdownMenu>
                    </MDBDropdown>
                    <div
                        className="volume-button"
                        onClick={() => {
                            const audio = audioRef.current;
                            if (audio) {
                                audio.muted = !audio.muted;
                                setMuted(audio.muted);
                            }
                        }}
                        style={{ cursor: "pointer" }}
                    >
                        <MDBIcon fas icon={muted ? "volume-mute" : "volume-up"} size="md" />
                    </div>

                    {isAudioAvailable && (
                        <audio
                            ref={audioRef}
                            src={ filetitle == "System Default" ? '': source}
                            preload="metadata"
                            onTimeUpdate={handleTimeUpdate}
                            onLoadedMetadata={handleLoadedMetadata}
                            onDurationChange={handleDurationChange}
                            onCanPlay={handleCanPlay}
                            onLoadedData={handleLoadedData}
                            onError={handleError}
                            onEnded={handleEnded}
                        />
                    )}
                </MDBCardBody>
            </MDBCard>
        </>
    );
}
